module.exports = __webpack_public_path__ + "static/media/morten.c4cff26b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/morten.jpg
// module id = 607
// module chunks = 0